/* eslint-disable */
import { createSlice } from "@reduxjs/toolkit";
import {
  convertISODateTime,
  convertDefaultTimeZoneStringToISO,
  roundToInterval,
} from "@utils/time-helpers";
import moment from "moment-timezone";

const initialState = {
  rich_media_url: null,
  saveEnabled: true,
  notification_id: "",
  message: "",
  title: "",
  message_type: "ScheduledMessage",
  start_date: null,
  inputISOStartDate: null,
  inputISOStopDate: null,
  stop_date: null,
  segment_ids: [],
  segments: [],
  script_type: null,
  script_value: null,
  scheduled_date: null,
  supplementalEnabled: true,
  supplemental_data: {},
  supplementalDataLoaded: false,
  imageDetails: {},
  product_url: "",
  selectedImage: {
    url: "",
    name: "",
    fileSize: "",
    height: null,
    width: null,
    base64: "",
  },
  showUploadImagePanel: false,
  showDropZoneNew: false,
  validInputs: false,
  errors: {},
  is_live: null,
};

const notificationNewViewSlice = createSlice({
  name: "notificationNewView",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase("STORE_IMAGE_DETAILS", (state, action) => {
        state.imageDetails[action.imageDetails.image] = {
          height: action.imageDetails.height,
          width: action.imageDetails.width,
          fitsPosition: action.imageDetails.fitsPosition,
        };
      })
      .addCase("SET_SHOW_UPLOAD_PANEL", (state, action) => {
        state.showUploadImagePanel = action.show;
      })
      .addCase("SET_SHOW_DROP_ZONE", (state, action) => {
        state.showDropZoneNew = action.show;
        state.showUploadImagePanel = false;
      })
      .addCase("DROP_FILE", (state, action) => {
        const file = action.file[0];
        state.showDropZoneNew = false;
        state.rich_media_url = action.base64;
        state.selectedImage.url = file.preview;
        state.selectedImage.name = file.name;
        state.selectedImage.fileSize = (file.size / 1024).toFixed(2);
      })
      .addCase("REMOVE_FILE", (state) => {
        state.rich_media_url = null;
        state.selectedImage.url = "";
        state.selectedImage.name = "";
        state.selectedImage.fileSize = "";
      })
      .addCase("RESET_FORM_FIELDS", () => initialState)
      .addCase("SET_TITLE", (state, action) => {
        state.title = action.title;
      })
      .addCase("SET_DESCRIPTION", (state, action) => {
        state.message = action.description;
      })
      .addCase("SET_NEW_DATE", (state, action) => {
        let timeString,
          combinedString,
          newISODateTime = null,
          dateToSet;
        if (action.dateString) {
          dateToSet =
            action.whatToSet === "startDate"
              ? state.inputISOStartDate
              : state.inputISOStopDate;
          timeString = dateToSet
            ? dateToSet
            : moment.tz("America/New_York").toISOString();
          timeString = convertISODateTime(
            roundToInterval(timeString, 15)
          ).toMomentWithConsoleConfigTimeZone.format("h:mmA");
          combinedString = action.dateString + timeString;
          newISODateTime = convertDefaultTimeZoneStringToISO(combinedString);
        }
        if (action.whatToSet === "startDate") {
          state.inputISOStartDate = newISODateTime;
        } else {
          state.inputISOStopDate = newISODateTime;
        }
      })
      .addCase("SET_NEW_TIME", (state, action) => {
        let dateString, combinedString, newISODateTime, dateToSet;
        dateToSet =
          action.whatToSet === "startTime"
            ? state.inputISOStartDate
            : state.inputISOStopDate;
        dateString =
          convertISODateTime(dateToSet).toMomentWithConsoleConfigTimeZone.format(
            "MM/DD/YYYY"
          );
        combinedString = dateString + action.timeString;
        newISODateTime = convertDefaultTimeZoneStringToISO(combinedString);
        if (action.whatToSet === "startTime") {
          state.inputISOStartDate = newISODateTime;
        } else {
          state.inputISOStopDate = newISODateTime;
        }
      })
      .addCase("SET_NOTIFICATION_TYPE", (state, action) => {
        state.message_type = action.notificationType;
      })
      .addCase("SET_USER_SEGMENT", (state, action) => {
        let modifiedSegments, modifiedSegmentIds;
        if (action.segment_id.length === 0) {
          modifiedSegments = [];
          modifiedSegmentIds = [];
        } else {
          modifiedSegments = state.segments.map((segment) => ({
            ...segment,
            checked:
              segment.segment_id === action.segment_id
                ? !segment.checked
                : segment.checked,
          }));
          modifiedSegmentIds = state.segment_ids.includes(action.segment_id)
            ? state.segment_ids.filter(
                (segmentId) => segmentId !== action.segment_id
              )
            : state.segment_ids.concat(action.segment_id);
        }
        state.segments = modifiedSegments;
        state.segment_ids = modifiedSegmentIds;
      })
      .addCase("SET_CONFIG", (state, action) => {
        const { notificationScriptTypes } = action.config;
        state.actionTypeOptions = {
          ...(state.actionTypeOptions || {}),
          actionTypes: notificationScriptTypes,
        };
      })
      .addCase("SET_ACTION_TYPE", (state, action) => {
        state.script_type = action.script_type;
      })
      .addCase("SET_ACTION_VALUE", (state, action) => {
        state.script_value = action.script_value;
      })
      .addCase("LOAD_NOTIFICATION", (state, action) => {
        Object.assign(state, action.payload);
      })
      .addCase("ENABLE_POST", (state, action) => {
        state.validInputs = !action.hasErrors;
      })
      .addCase("SET_ERROR", (state, action) => {
        if (action.error.errorName) {
          state.errors[action.error.errorName] = action.error.errorPresent;
        } else {
          Object.assign(state.errors, action.error);
        }
      })
      .addCase("DISABLE_SAVE", (state) => {
        state.saveEnabled = false;
      })
      .addCase("LOAD_STATUS_DETAIL", (state, action) => {
        state.notification_id = action.idTarget;
        state.is_live = action.itemStatus;
      });
  },
});

export const selectNotificationNewView = (state) => state.notificationNewView;

export default notificationNewViewSlice.reducer;
